"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.File = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var File = function (_a) {
    var _b = _a.color, color = _b === void 0 ? helios_styles_1.icon.default : _b;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.58579 1.2518C2.96086 0.876729 3.46957 0.666016 4 0.666016H9.66667C9.84348 0.666016 10.013 0.736253 10.1381 0.861278L13.8047 4.52794C13.9298 4.65297 14 4.82254 14 4.99935V13.3327C14 13.8631 13.7893 14.3718 13.4142 14.7469C13.0391 15.122 12.5304 15.3327 12 15.3327H4C3.46957 15.3327 2.96086 15.122 2.58579 14.7469C2.21071 14.3718 2 13.8631 2 13.3327V2.66602C2 2.13558 2.21071 1.62687 2.58579 1.2518ZM12.0572 4.66602L10 2.60882V4.66602H12.0572ZM8.66667 1.99935V5.33268C8.66667 5.70087 8.96514 5.99935 9.33333 5.99935H12.6667V13.3327C12.6667 13.5095 12.5964 13.6791 12.4714 13.8041C12.3464 13.9291 12.1768 13.9993 12 13.9993H4C3.82319 13.9993 3.65362 13.9291 3.5286 13.8041C3.40357 13.6791 3.33333 13.5095 3.33333 13.3327V2.66602C3.33333 2.4892 3.40357 2.31964 3.5286 2.19461C3.65362 2.06959 3.82319 1.99935 4 1.99935H8.66667Z", fill: color }) })));
};
exports.File = File;
